/* main.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./main.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment } from 'react';
import { useSkipLink } from '../../../context/skip-links/skip-links-context';
import { contentHeightWhenFixed, contentInsetBlockStart } from '../constants';
import { usePrefixedUID } from '../use-prefixed-id';
import { MainStickyContext } from './main-sticky-context';
var mainElementStyles = {
  root: "_nd5l1gzg _19121cl4 _qwfh1wug",
  fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
};
export function Main(_ref) {
  var children = _ref.children,
    isFixed = _ref.isFixed,
    xcss = _ref.xcss,
    _ref$skipLinkLabel = _ref.skipLinkLabel,
    skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Main Content' : _ref$skipLinkLabel,
    testId = _ref.testId,
    id = _ref.id;
  var UID = usePrefixedUID();
  var CID = id ? id : UID;
  useSkipLink(CID, skipLinkLabel);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: CID,
    "data-layout-slot": true,
    className: ax([mainElementStyles.root, isFixed && mainElementStyles.fixedContentArea, xcss]),
    role: "main",
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(MainStickyContext.Provider, {
    value: Boolean(isFixed)
  }, children)));
}